import { render } from "./UserImageDialog.vue?vue&type=template&id=5397f76f"
import script from "./UserImageDialog.vue?vue&type=script&lang=js"
export * from "./UserImageDialog.vue?vue&type=script&lang=js"

import "./UserImageDialog.vue?vue&type=style&index=0&id=5397f76f&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__